const isDeepEqual = (object1: any, object2: any) => {
    const objKeys1 = Object.keys(object1).filter((key) => object1[key] !== undefined);
    const objKeys2 = Object.keys(object2).filter((key) => object2[key] !== undefined);

    if (objKeys1.length !== objKeys2.length) return false;

    for (var key of objKeys1) {
        const value1 = object1[key];
        const value2 = object2[key];

        const isObjects = isObject(value1) && isObject(value2);

        if ((isObjects && !isDeepEqual(value1, value2)) || (!isObjects && value1 !== value2)) {
            return false;
        }
    }
    return true;
};

const isObject = (object: any) => {
    return object != null && typeof object === 'object';
};

export default isDeepEqual;
